import React from "react";
//import "../fieldComponent.css";

const DEFAULT_HEIGHT = "100px";

const htmlcomp = props => {
  const {
    gethtml,
  } = props;

  const height = props.height || DEFAULT_HEIGHT;

  return (
    <div>
        {gethtml()}
    </div>
  );
};

export default htmlcomp;
